var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditEan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 1L13 3.18182M13 3.18182L10.3333 5.36364M13 3.18182H3.66667C2.95942 3.18182 2.28115 3.41169 1.78105 3.82086C1.28095 4.23003 1 4.78498 1 5.36364V6.45455M3.66667 13L1 10.8182M1 10.8182L3.66667 8.63636M1 10.8182H10.3333C11.0406 10.8182 11.7189 10.5883 12.219 10.1791C12.719 9.76997 13 9.21502 13 8.63636V7.54545",
    stroke: "#5062F0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditEan);
export default __webpack_public_path__ + "static/media/editEan.c03697a6bb9d278aa4ff148bc4d65d5b.svg";
export { ForwardRef as ReactComponent };